import {Component, inject, input} from '@angular/core';
import {ProjectStepRichTextService} from '../../../../../../../shared/services/project-step-rich-text.service';
import {rxResource} from '@angular/core/rxjs-interop';
import {
  SystemRecordingsOverviewControllerService,
  SystemRecordingIntegrationControllerService,
} from '@frontend/shared';
import {LoadingComponent} from '../../../../../../../shared/components/loading/loading.component';
import {SystemRecordingIntegrationPanelsComponent} from './components/system-recording-integration-panels/system-recording-integration-panels.component';

@Component({
  selector: 'app-step-8-2-2-rfq-system-integration',
  providers: [ProjectStepRichTextService],
  imports: [LoadingComponent, SystemRecordingIntegrationPanelsComponent],
  templateUrl: './step-8-2-2-rfq-system-integration.component.html',
})
export class Step822RfqSystemIntegrationComponent {
  readonly projectId = input.required<number>();

  private readonly systemRecordingsOverviewController = inject(
    SystemRecordingsOverviewControllerService,
  );
  private readonly systemRecordingIntegrationController = inject(
    SystemRecordingIntegrationControllerService,
  );

  protected readonly currentOfficeSystemRecordingResource = rxResource({
    params: () => ({
      projectId: this.projectId()!,
    }),
    stream: ({params: request}) => {
      return this.systemRecordingsOverviewController.getCurrentSystemRecordingsOverview({
        projectId: request.projectId,
      });
    },
  });

  protected readonly targetOfficeSystemRecordingResource = rxResource({
    params: () => ({
      projectId: this.projectId()!,
    }),
    stream: ({params: request}) => {
      return this.systemRecordingsOverviewController.getTargetSystemRecordingsOverview({
        projectId: request.projectId,
      });
    },
  });

  protected readonly integrationSystemRecordingsResource = rxResource({
    params: () => ({projectId: this.projectId()}),
    stream: ({params: request}) =>
      this.systemRecordingIntegrationController.getSystemIntegrations1(request),
  });
}
